import gql from '@my/graphql'
import msg from '../config/messages'
import modals from '@my/store/modals'
import filters from '../config/filters'

export default {
  methods: {
    async getVariablesApp (rootState, gqlModel) {
      const query = gqlModel.GET_VARIABLES_APP
      const response = await gql.query(query, {})

      if (response) {
        rootState.variables = response.data.getVariablesApp
      }
    },

    async getOne (gqlModel, options) {
      const query = gqlModel.GET_ONE

      const response = await gql.query(query, options)

      return response
    },

    async getData (rootState, state, gqlModel, resolver, page, key = '', history = false) {
      const options = JSON.parse(JSON.stringify(rootState.filters[resolver]))

      const english = {
        creada: 'created',
        aprobada: 'approved',
        pagada: 'paid',
        empacada: 'packed',
        enviada: 'sent'
      }

      try {
        if (options.search) {
          for (const key in english) {
            options.search = options.search.split(key).join(english[key])
          }
        }

        if (options.search1) {
          for (const key in english) {
            options.search1 = options.search1.split(key).join(english[key])
          }
        }
      } catch (error) {
        console.log(error)
      }

      const query = history ? gqlModel.GET_HISTORY : gqlModel.GET_ALL

      options.page = page

      const response = await gql.query(query, options)

      if (response) {
        state[resolver].data = response.data[`get${filters.capitalize(resolver)}`]

        if (!history) {
          const newData = state[resolver].new
          const docs = state[resolver].data.docs

          state[resolver].new = newData.filter(data => docs.findIndex(doc => doc[key] === data[key]) < 0)
        }
      }
    },

    async newData (gqlModel, resolver, key, graphqlName = '', mutationName = '') {
      const data = this.cleanData(this.dataForm)
      const mutation = graphqlName ? gqlModel[graphqlName] : gqlModel.NEW

      const variables = {}
      variables[resolver] = data

      console.log(variables)

      const response = await gql.mutate(mutation, variables)

      if (response) {
        const dataCreated = response.data[mutationName || `new${filters.capitalize(resolver)}`]
        modals.showMessage({ message: msg.message.default.CREATED.message(dataCreated[key], resolver) })

        this.initForm()
      }
    },

    async updateData (gqlModel, resolver, key, sendNotifications) {
      const dataUpdate = this.dataUpdate()

      if (!dataUpdate) {
        modals.showMessage({ message: msg.message.all.NOTHING_CHANGED.message, type: 'error' })
      } else {
        const variables = {}
        const findKey = this.findKey || key
        console.log(findKey, 'key')
        console.log(this.dataOriginal[findKey], 'dataOriginal[key]')
        variables[findKey] = this.dataOriginal[findKey]
        variables[`${resolver}Update`] = dataUpdate
        console.log(`${resolver}Update`, '0000')
        console.log(variables, 'variables'	)

        if (typeof sendNotifications === 'boolean') variables.sendNotifications = sendNotifications

        const response = await gql.mutate(gqlModel.UPDATE, variables)

        if (response) {
          const dataUpdated = response.data[`update${filters.capitalize(resolver)}`]
          modals.showMessage({ message: msg.message.default.UPDATED.message(dataUpdated[key], resolver) })
        }
      }
    },

    async deleteData (gqlModel, resolver, key) {
      const variables = {}
      const findKey = this.findKey || key
      variables[findKey] = this.dataOriginal[findKey]
      const response = await gql.mutate(gqlModel.DELETE, variables)

      if (response) {
        const dataDeleted = response.data[`delete${filters.capitalize(resolver)}`]
        modals.showMessage({ message: msg.message.default.DELETED.message(dataDeleted[key], resolver) })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/db.js